"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AuthenticationMiddlewareGenerator = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _client = require("@apollo/client");
var _reactRouterDom = require("react-router-dom");
var _Actions = require("../store/actions/Actions");
var _config = _interopRequireDefault(require("./config"));
var _excluded = ["component", "loginState"],
  _excluded2 = ["component"],
  _excluded3 = ["component", "loginState"],
  _excluded4 = ["component", "loginState"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
/**
 * Generate a Authentication Provider component with the custom configuration applied
 *
 * @param {object} [uiConfig]
 * @returns {object} { AuthProvider }
 */
var AuthenticationMiddlewareGenerator = function AuthenticationMiddlewareGenerator() {
  var uiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.default;
  var config = uiConfig.config,
    functions = uiConfig.functions;
  var deleteFromLocalStorage = functions && typeof functions.deleteFromLocalStorage === 'function' ? functions.deleteFromLocalStorage : _config.default.functions.deleteFromLocalStorage;
  var enableAuthentication = config && typeof config.enableAuthentication === 'boolean' ? config.enableAuthentication : _config.default.config.enableAuthentication;
  var loginPath = config && typeof config.loginPath === 'string' ? config.loginPath : _config.default.config.loginPath;
  var requestAccessPath = config && typeof config.requestAccessPath === 'string' ? config.requestAccessPath : _config.default.config.requestAccessPath;
  var PUBLIC_ACCESS = config && typeof config.PUBLIC_ACCESS === 'string' ? config.PUBLIC_ACCESS : _config.default.config.PUBLIC_ACCESS;
  var GET_USER_DETAILS = config && typeof config.GET_USER_DETAILS === 'string' ? config.GET_USER_DETAILS : _config.default.config.GET_USER_DETAILS;
  var accessLevelTypes = config && typeof config.accessLevelTypes === 'string' ? config.accessLevelTypes : _config.default.config.accessLevelTypes;
  var userRoles = config && typeof config.userRoles === 'string' ? config.userRoles : _config.default.config.userRoles;
  var membershipStatus = config && typeof config.membershipStatus === 'string' ? config.membershipStatus : _config.default.config.membershipStatus;
  var stateProps = function stateProps(state) {
    return {
      loginState: state.login
    };
  };
  var dispatchProps = function dispatchProps(dispatch) {
    return {
      signIn: function signIn(data) {
        return dispatch((0, _Actions.signInRed)(data));
      },
      signOut: function signOut() {
        return dispatch((0, _Actions.signOutRed)());
      }
    };
  };
  var FetchUserDetails = function FetchUserDetails(props) {
    var children = props.children,
      path = props.path,
      signIn = props.signIn,
      signOut = props.signOut;
    var _ref2 = (0, _react.useState)(true),
      _ref3 = _slicedToArray(_ref2, 2),
      localLoading = _ref3[0],
      setLocalLoading = _ref3[1];
    var _ref4 = (0, _client.useLazyQuery)(GET_USER_DETAILS, {
        context: {
          clientName: 'userService'
        },
        fetchPolicy: 'no-cache',
        onCompleted: function onCompleted(data) {
          var userDetails = data.getMyUser;
          userDetails.role = userDetails.role.toLowerCase();
          userDetails.userStatus = userDetails.userStatus.toLowerCase();
          signIn(userDetails);
          setLocalLoading(false);
        },
        onError: function onError(_ref) {
          var graphQLErrors = _ref.graphQLErrors;
          if (graphQLErrors) {
            signOut();
            deleteFromLocalStorage('userDetails');
          }

          // To retry on network errors, we recommend the RetryLink
          // instead of the onError link. This just logs the error.
          setLocalLoading(false);
        }
      }),
      _ref5 = _slicedToArray(_ref4, 2),
      getUserDetails = _ref5[0],
      loading = _ref5[1].loading;
    (0, _react.useEffect)(function () {
      setLocalLoading(true);
      getUserDetails();
    }, [path]);
    if (loading || localLoading) return /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
  };
  var LoginRoute = function LoginRoute(props) {
    var ChildComponent = props.component,
      loginState = props.loginState,
      rest = _objectWithoutProperties(props, _excluded);
    var isSignedIn = loginState.isSignedIn;
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      render: function render(routeProps) {
        if (enableAuthentication && isSignedIn || !enableAuthentication) {
          return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
            to: "/"
          });
        }
        return /*#__PURE__*/_react.default.createElement(ChildComponent, _extends({}, routeProps, {
          match: rest.computedMatch
        }, rest));
      }
    });
  };
  var MixedRoute = function MixedRoute(props) {
    var ChildComponent = props.component,
      rest = _objectWithoutProperties(props, _excluded2);
    if (!enableAuthentication) {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        render: function render(routeProps) {
          return /*#__PURE__*/_react.default.createElement(ChildComponent, _extends({}, routeProps, {
            match: rest.computedMatch
          }, rest));
        }
      });
    }
    var path = rest.path;
    return /*#__PURE__*/_react.default.createElement(FetchUserDetails, _extends({
      path: path
    }, props), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      render: function render(routeProps) {
        return /*#__PURE__*/_react.default.createElement(ChildComponent, _extends({}, routeProps, {
          match: rest.computedMatch
        }, rest));
      }
    }));
  };
  var PrivateRoute = function PrivateRoute(props) {
    var ChildComponent = props.component,
      loginState = props.loginState,
      rest = _objectWithoutProperties(props, _excluded3);
    var isSignedIn = loginState.isSignedIn,
      _loginState$role = loginState.role,
      role = _loginState$role === void 0 ? '' : _loginState$role,
      _loginState$userStatu = loginState.userStatus,
      userStatus = _loginState$userStatu === void 0 ? '' : _loginState$userStatu;
    if (!enableAuthentication) {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        render: function render(routeProps) {
          return /*#__PURE__*/_react.default.createElement(ChildComponent, _extends({}, routeProps, {
            match: rest.computedMatch
          }, rest));
        }
      });
    }

    // Enums
    var NONE = accessLevelTypes.NONE,
      METADATA_ONLY = accessLevelTypes.METADATA_ONLY;
    var ADMIN = userRoles.ADMIN,
      NONMEMBER = userRoles.NONMEMBER;
    var ACTIVE = membershipStatus.ACTIVE;
    var _ref6 = (0, _reactRouterDom.useLocation)(),
      pathname = _ref6.pathname;
    var access = rest.access,
      path = rest.path,
      requiuredSignIn = rest.requiuredSignIn;
    var updatedRole = userStatus !== ACTIVE && role !== ADMIN ? NONMEMBER : role;
    var hasAccess = isSignedIn && access.includes(updatedRole);
    return /*#__PURE__*/_react.default.createElement(FetchUserDetails, _extends({
      path: path
    }, props), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      render: function render(routeProps) {
        if (PUBLIC_ACCESS === NONE) {
          if (!isSignedIn) {
            var base = loginPath;
            var redirectPath = "".concat(base, "?redirect=").concat(pathname);
            return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
              to: redirectPath
            });
          }
          if (!hasAccess) {
            var _redirectPath = role.toLowerCase() !== ADMIN ? "".concat(requestAccessPath, "?type=noAccess") : '/';
            return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
              to: _redirectPath
            });
          }

          // Condition for admins who are inactive & skipping it for profile route.
          if (path !== '/profile' && role === ADMIN && userStatus !== ACTIVE) {
            return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
              style: {
                textAlign: 'center'
              }
            }, "Inactive Admin Account!"));
          }
        }
        if (PUBLIC_ACCESS === METADATA_ONLY) {
          if (requiuredSignIn && !isSignedIn) {
            return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
              to: "/"
            });
          }

          // Condition for admins who are inactive & skipping it for profile route.
          if (requiuredSignIn && path !== '/profile' && role === ADMIN && userStatus !== ACTIVE) {
            return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
              style: {
                textAlign: 'center'
              }
            }, "Inactive Account!"));
          }
        }
        return /*#__PURE__*/_react.default.createElement(ChildComponent, _extends({}, routeProps, {
          match: rest.computedMatch
        }, rest));
      }
    }));
  };
  var AdminRoute = function AdminRoute(props) {
    var ChildComponent = props.component,
      loginState = props.loginState,
      rest = _objectWithoutProperties(props, _excluded4);
    var _loginState$role2 = loginState.role,
      role = _loginState$role2 === void 0 ? '' : _loginState$role2;
    var ADMIN = userRoles.ADMIN;
    if (!enableAuthentication) {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        render: function render() {
          return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
            to: "/"
          });
        }
      });
    }

    // Check if this one is not Admin, Send them back to Home.
    if (role !== ADMIN) {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        render: function render() {
          return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
            to: "/"
          });
        }
      });
    }
    return /*#__PURE__*/_react.default.createElement(PrivateRoute, _extends({
      component: ChildComponent
    }, rest, props));
  };
  return {
    // @ts-ignore
    // eslint-disable-next-line max-len
    LoginRoute: (0, _reactRedux.connect)(stateProps, dispatchProps)(LoginRoute),
    MixedRoute: (0, _reactRedux.connect)(stateProps, dispatchProps)(MixedRoute),
    PrivateRoute: (0, _reactRedux.connect)(stateProps, dispatchProps)(PrivateRoute),
    AdminRoute: (0, _reactRedux.connect)(stateProps, dispatchProps)(AdminRoute)
  };
};
exports.AuthenticationMiddlewareGenerator = AuthenticationMiddlewareGenerator;
var _default = AuthenticationMiddlewareGenerator;
exports.default = _default;